import { useState } from "react";

import { trackAmplitudeEvent } from "../../amplitude";
import { STORIES_EVENTS } from "./storiesEvents";
import { requestJson } from "./storiesHelpers";

export default function useSaveStoryWord({ eventProperties, isPro, quickCaptureEntriesUrl, onProRequired }) {
  const [savingWord, setSavingWord] = useState(null);
  const [savedWords, setSavedWords] = useState(new Set());
  const [toast, setToast] = useState(null);

  const saveWord = async (word) => {
    if (!isPro) {
      onProRequired();
      return;
    }
    setSavingWord(word);
    try {
      await requestJson({ data: { quick_capture_entry: { text: word } }, method: "post", url: quickCaptureEntriesUrl });
      trackAmplitudeEvent(STORIES_EVENTS.WORD_SAVED, { ...eventProperties, word });
      setSavedWords((previous) => new Set(previous).add(word));
      setToast({ content: "Saved to Quick Capture", context: "success", id: Date.now() });
    } catch {
      setToast({ content: "Failed to add entry. Please try again.", context: "danger", id: Date.now() });
    } finally {
      setSavingWord(null);
    }
  };

  return { saveWord, savedWords, savingWord, toast };
}
